/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import baustein from "baustein";

const filteringClass = "lyst-main--filtering";


export default baustein.register("feed-main", {
    showFilteringOverlay: function() {
        this.el.classList.add(filteringClass);
    },

    hideFilteringOverlay: function() {
        this.el.classList.remove(filteringClass);
    },
});

